jQuery(document).ready(function( $ ) {
  $( ".hamburger-menu .menu__item" ).each(function() {
    if ($(this).children('ul.menu').length > 0) {
      $(this).children('a').after('<span class="menu__dropdown-btn">&nbsp;</span>');

      // Add active class if the menu item is active
      const $dropdownBtn = $(this).find('.menu__dropdown-btn');
      if ($(this).hasClass('menu__item--active-trail')) {
        $dropdownBtn.addClass('is-active');
      }
    }
  });

  $('.menu__dropdown-btn').click(function() {
		if ($(this).hasClass("is-active")) {
			$(this).removeClass('is-active');
			$(this).next('.menu').slideUp('normal');
		} else {
			$(this).addClass('is-active');
			$(this).next('.menu').slideDown('normal');
		}
		return false;
	});
});
